/*
 * @Author: your name
 * @Date: 2021-04-01 10:08:43
 * @LastEditTime: 2022-08-08 15:06:11
 * @LastEditors: wangjiaxiang
 * @Description: In User Settings Edit
 * @FilePath: /星妈会拆分项目/xmh-front-content/src/minxs/audio.js
 */
import { isUserLogin,globalGoLogin } from "@/assets/js/common.js";
export const audioMixins = {
  data() {
    return {
      play: require("../assets/images/icon/audio_gif.gif"), //播放中动图
      playDoctor: require("../assets/images/icon/audio_gifA.gif"), //播放中动图
      off: require("../assets/images/icon/off.png"), //暂停图片
    };
  },
  methods: {
    isUserLogin,
    /**
     * @description: 跳转详情
     * @param {item} 音频信息
     * @param {index} 音频下标
     * @param {id} 音频id
     * @return {*}
     */
    onLinkTap(item, index, id) {
      if(id){
        //id为list的时候 代表是音频列表进入的详情 需要清除添加的最新音频标记
        if(id == 'list'){
          item.only = ''
        }
      }

      if (this.type == "cagechild") {
        if (item.id != this.$parent.$parent.$refs.musicAudio.newId()) {
          this.playIndex = index; //id不相等 直接赋值下标 最新跟列表的切换
          this.$parent.$parent.$refs.musicAudio.$refs.player.currentTime = 0; //id不相等 相当于切换音频 直接时间清零
        }
      } else if (item.id != this.$refs.musicAudio.newId()) {
        this.playIndex = index;
        this.$refs.musicAudio.$refs.player.currentTime = 0;
      }
      var sign = 0; //0为列表 1为最新
      var SIZE =
        this.type === "cagechild"
          ? this.$parent.$parent.pageParams.size
          : this.pageParams.size;
      // 凯奇育儿未注册可以进入详情听
      if (this.isUserLogin() && (this.type != "audio" && this.type != "cagechild" && this.type != "doctorHome")) {
        globalGoLogin()
      } else {
        //判断是谁进入详情音频 only为最新音频
        if (item.only) {
          sign = 1;
          this.list = this.allNewAudio || this.$parent.$parent.allNewAudio;
          SIZE =
            this.type === "cagechild"
              ? this.$parent.$parent.newPageParams.size
              : this.newPageParams.size;
        } else {
          sign = 0;
          this.list = this.audioList;
        }
        const pageSize = Math.floor(index / SIZE) + 1;

        if (item.id === this.list[this.playIndex].id) {
          this.audioParams = {};
          this.$store.commit("saveAuidoTime", {
            id: item.id,
            time:
              this.type === "cagechild"
                ? this.$parent.$parent.$refs.musicAudio.$refs.player.currentTime
                : this.$refs.musicAudio.$refs.player.currentTime,
            page: pageSize,
          });
          console.log(this.$store);
        } else {
          this.$store.commit("saveAuidoTime", {
            id: item.id,
            time: 0,
            page: pageSize,
          });
        }

        let paramsO = {
          expertId: item.id,
          id: item.id,
          type: this.type,
          sign: sign, //1为最新 2为列表
          isKq:item.collectType,
          doctorId:id
        };
        if (this.type === "cagechild") {
          Object.assign(paramsO, {
            tagAgeId: this.$parent.$parent.audiObj.tagAgeId,
            tagClassId: this.$parent.$parent.audiObj.tagClassId,
          });
        }
        console.log(this.$route.query.share)
        let str=this.$route.query.share==="cagechild"?'cagechild':''

        // this.cancelPlay()
        this.$router.push({
          name: "audiodetail",
          query: {
            ...paramsO,
            share:str
          },
        });
      }
    },

  },

  filters: {
    // 音频日期
    audioPlayDate(val) {
      let dayArr = val.split(" ")[0];
      let newArr = dayArr.split("-").slice(0);
      newArr.shift();
      return newArr.join("/");
    },
  },
};
